import { render, staticRenderFns } from "./DashboardT.vue?vue&type=template&id=01ff7124"
import script from "./DashboardT.vue?vue&type=script&lang=js"
export * from "./DashboardT.vue?vue&type=script&lang=js"
import style0 from "./DashboardT.vue?vue&type=style&index=0&id=01ff7124&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports